class CartSubscriptionSelector extends HTMLElement {
  constructor() {
    super();
    this.checkboxInput = this.querySelector(
      ".cart-subscription-selector__input"
    );
    this.selectorWrapper = this.querySelector(
      ".cart-subscription-selector__options-wrapper"
    );
    this.selectorSelect = this.querySelector(
      ".cart-subscription-selector__select"
    );
    this.selectorOptions = this.selectorSelect.options;
    this.upsellProductsCard = document.querySelectorAll(".cart-item-upsell");
    this.upsellSelectedProductCard = "";
    this.otpProductCard = document.querySelector(".cart-item-otp");
    this.otpProductPrice = document.querySelector(
      ".cart-subscription-selector__original-price"
    );
    this.otpItemId = this.otpProductCard?.dataset.itemId;
    this.subscriptionSave = this.querySelector(
      ".cart-subscription-selector__save"
    );
    this.cardItemPrice = "";
    this.quantity = this.otpProductCard
      ? this.otpProductCard.querySelector(".quantity__input")?.value || 1
      : 1;
    this.checkboxPrice = this.querySelector(
      ".cart-subscription-selector__price"
    );
    this.cartDrawerFooterPrice = document.querySelector(
      ".cart-drawer__footer .totals__subtotal-value"
    );
    this.productPrice = this.selectorOptions?.[0]?.dataset.productPrice;
    this.frecuency = parseInt(
      this.selectorOptions?.[0]?.dataset.productFrecuency || 1
    );
    this.checkboxInput.addEventListener(
      "change",
      this.handleCheckbox.bind(this)
    );
    this.selectorSelect.addEventListener(
      "change",
      this.handleSelection.bind(this)
    );
    this.itemData = {
      id: "",
      quantity: this.quantity,
    };
    this.handleDiscountPercentage();
  }

  handleDiscountPercentage() {
    // Find the one-time purchase variant (the one without a selling plan)
    const otpOption = Array.from(this.selectorOptions).find(
      (option) =>
        !option.dataset.productSellingPlan ||
        option.dataset.productSellingPlan === ""
    );
    const otpPrice =
      otpOption?.dataset.productPrice ||
      this.otpProductCard?.dataset.productPrice;

    // Get the currently selected subscription option (or first one if none selected)
    const selectedOption = this.selectorSelect.value
      ? Array.from(this.selectorOptions).find(
          (option) => option.value == this.selectorSelect.value
        )
      : this.selectorOptions?.[0];

    const subscriptionPrice =
      selectedOption?.dataset.productPrice || this.productPrice;
    const frequency = parseInt(
      selectedOption?.dataset.productFrecuency || this.frecuency || 1
    );

    // Calculate number of boxes based on frequency (1 = 1 box, 3 = 3 boxes)
    const number_of_boxes = frequency;

    // Calculate savings: (one-time price × number_of_boxes) - subscription price
    // This matches the calculation used on the product page
    const saveAmount = otpPrice * number_of_boxes - subscriptionPrice;

    if (saveAmount > 0) {
      this.subscriptionSave.innerHTML = `SAVE ${Shopify.formatMoney(
        saveAmount
      )}`;
    } else {
      this.subscriptionSave.innerHTML = "";
    }
    this.otpProductPrice.innerHTML = Shopify.formatMoney(otpPrice);
  }

  handleCheckbox(event) {
    event.preventDefault();
    const checked = event.target.checked;
    checked
      ? this.classList.add("selected")
      : this.classList.remove("selected");
    checked
      ? this.selectorSelect.removeAttribute("disabled")
      : this.selectorSelect.setAttribute("disabled", "disabled");
    this.handleSelection(checked);
  }

  async handleSelection(checked) {
    if (checked) {
      const selectedProductId = this.selectorSelect.value;
      const selectedProductOption = Array.from(this.selectorOptions).find(
        (option) => option.value == selectedProductId
      );
      this.otpProductCard?.classList.add("otp-hidden");
      this.upsellProductsCard.forEach((upsellProduct) => {
        upsellProduct.classList.add("hidden");
        upsellProduct.dataset.productId == selectedProductId &&
          (this.upsellSelectedProductCard = upsellProduct);
        const quantityInput =
          this.upsellSelectedProductCard.querySelector("quantity-input");
        if (quantityInput) {
          quantityInput.addEventListener(
            "change",
            this.handleQuantitySelector.bind(this)
          );
        }
      });
      this.productPrice = selectedProductOption?.dataset.productPrice;
      this.frecuency = selectedProductOption?.dataset.productFrecuency;
      this.itemData.id = selectedProductId;
      this.itemData.selling_plan =
        selectedProductOption?.dataset.productSellingPlan;

      this.updateItemInfo();
      this.handleDiscountPercentage();
      await this.handleCart(this.itemData);
      window?.giftProductManager?.debouncedCheck();
    } else {
      this.otpProductCard?.classList.remove("otp-hidden");
      this.upsellProductsCard.forEach((upsellProduct) => {
        upsellProduct.classList.add("hidden");
      });
      this.upsellSelectedProductCard = this.otpProductCard;
      this.productPrice = this.otpProductCard?.dataset.productPrice;
      this.itemData.id = this.otpProductCard?.dataset.productId;
      this.itemData.quantity = 1;
      delete this.itemData.selling_plan;
      await this.handleCart(this.itemData);
      window?.giftProductManager?.debouncedCheck();
    }
  }

  async handleCart(itemData) {
    try {
      await this.clearCart();
      await this.addToCart(itemData);
    } catch (error) {
      console.error("Error", error);
    }
  }

  async addToCart(formData) {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }
  async clearCart() {
    try {
      const response = await fetch(
        window.Shopify.routes.root + "cart/clear.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  }

  handleQuantitySelector(event) {
    this.quantity = event.target.value;
    this.itemData.quantity = this.quantity;
    this.handleCart(this.itemData);
    this.updateItemInfo();
  }

  updateItemInfo() {
    const currentPrice = Shopify.formatMoney(
      this.productPrice * parseInt(this.itemData.quantity)
    );
    this.cardItemPrice =
      this.upsellSelectedProductCard?.querySelector(".price.price--end");
    this.checkboxPrice.innerHTML = currentPrice;
    this.cartDrawerFooterPrice.innerHTML = currentPrice;
    this.cardItemPrice.innerHTML = currentPrice;

    this.upsellSelectedProductCard?.classList.remove("hidden");
    const quantityInput =
      this.upsellSelectedProductCard?.querySelector(".quantity__input");
    if (quantityInput) {
      quantityInput.value = this.quantity;
    }
  }
  getCart() {
    fetch(window.Shopify.routes.root + "cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        console.log(data);
      })
      .catch(function (error) {
        console.error("Error:", error);
      });
  }
}

customElements.define("cart-subscription-selector", CartSubscriptionSelector);
